// Field definitions for the ContentHeaderPanel.
// Add, remove or reorder fields here — the component renders whatever is in this array.
// order: integer, used for user-defined ordering via UserSettings (lower = first)
// row: 1 = functional (type, importance, prio), 2 = metadata (stage, cat, dates)
// width: fixed px string (e.g. '160px') or null when flex is used
// flex: percentage string (e.g. '20%') or null when width is used
// getDisplayValue: optional fn(rawValue) => display string, or null to use raw value
// getValueColor: optional fn(rawValue) => CSS color string, or null for var(--j-text)
// labelColor: CSS color string or null for var(--j-muted)

const getImportanceDisplay = (val) => {
    if (val === 900) return 'High';
    if (val === 500) return 'Medium';
    if (val === 100) return 'Low';
    return '—';
};

// Receives raw numeric value (900/500/100), not display string
const getImportanceColor = (val) => {
    if (val === 900) return 'var(--j-danger)';
    if (val === 500) return 'var(--j-medium)';
    if (val === 100) return 'var(--j-muted)';
    return 'var(--j-text)';
};

export const CONTENT_HEADER_FIELD_DEFS = [
    {
        key: 'type',
        label: 'Type',
        order: 1,
        row: 1,
        type: 'text',
        width: '120px',
        flex: null,
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },
    {
        key: 'importanceId',
        label: 'Importance',
        order: 2,
        row: 1,
        type: 'text',
        width: '140px',
        flex: null,
        labelColor: null,
        getDisplayValue: getImportanceDisplay,
        getValueColor: getImportanceColor,
    },
    {
        key: 'prioId',
        label: 'Prio',
        order: 3,
        row: 1,
        type: 'text',
        width: '120px',
        flex: null,
        labelColor: null,
        getDisplayValue: getImportanceDisplay,
        getValueColor: getImportanceColor,
    },
    {
        key: 'stage',
        label: 'Stage',
        order: 4,
        row: 2,
        type: 'text',
        width: '120px',
        flex: null,
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },
    {
        key: 'cat',
        label: 'Cat',
        order: 5,
        row: 2,
        type: 'text',
        width: null,
        flex: '15%',
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },
    {
        key: 'ems',
        label: 'Created',
        order: 6,
        row: 2,
        type: 'date',
        width: '180px',
        flex: null,
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },
    {
        key: 'updatedOn',
        label: 'Updated',
        order: 7,
        row: 2,
        type: 'date',
        width: '180px',
        flex: null,
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },

    {
        key: 'stateId',
        label: 'State',
        order: 4,
        row: 1,
        type: 'text',
        width: '120px',
        flex: null,
        labelColor: null,
        getDisplayValue: (val) => {
            if (val === 0) return 'Active';
            if (val === 1) return 'Completed';
            if (val === 100) return 'Approved';
            if (val === 999) return 'Deleted';
            return '—';
        },
        getValueColor: (val) => {
            if (val === 0) return '#4cceac';
            if (val === 1) return '#66b2ff';
            if (val === 100) return '#4cceac';
            if (val === 999) return '#ff6b6b';
            return 'var(--j-text)';
        },
    },

    {
        key: 'format',
        label: 'Format',
        order: 4,
        row: 1,
        type: 'text',
        width: null,
        flex: '15%',
        labelColor: null,
        getDisplayValue: null,
        getValueColor: null,
    },
];
